document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hero-slideshow').forEach(initHeroSlideshow);
});

function initHeroSlideshow(root) {
  var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
  if (!slides.length) return;

  var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slideshow__dot'));
  var prevBtn = root.querySelector('.hero-slideshow__arrow--prev');
  var nextBtn = root.querySelector('.hero-slideshow__arrow--next');

  var autoplay = root.dataset.autoplay === 'true';
  var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
  var current = 0;
  var timer = null;

  function goTo(index) {
    var next = (index + slides.length) % slides.length;

    slides[current].classList.remove('is-active');
    slides[current].setAttribute('aria-hidden', 'true');
    pauseVideoIn(slides[current]);

    slides[next].classList.add('is-active');
    slides[next].removeAttribute('aria-hidden');
    playVideoIn(slides[next]);

    if (dots.length) {
      dots[current] && dots[current].classList.remove('is-active');
      dots[next] && dots[next].classList.add('is-active');
    }

    current = next;
  }

  function playVideoIn(slide) {
    var video = slide.querySelector('video');
    if (video) {
      video.play().catch(function () {});
    }
  }

  function pauseVideoIn(slide) {
    var video = slide.querySelector('video');
    if (video) video.pause();
  }

  function startAutoplay() {
    if (!autoplay || slides.length < 2) return;
    stopAutoplay();
    timer = setInterval(function () { goTo(current + 1); }, speed);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  // initial state
  slides[0].classList.add('is-active');
  playVideoIn(slides[0]);

  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
  });

  // pause on hover/focus so people can read text or watch video
  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  // pause when tab isn't visible (saves resources, avoids desync)
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAutoplay();
    else startAutoplay();
  });

  startAutoplay();
}